import { create } from 'zustand';

import boardService from 'services/board/board-service';

// 관리자 게시판관리(module_board)에 등록된 게시판 목록 전역 상태.
// boards: null = 아직 로드 전/실패, [] 이상 = 로드 성공 (use_yn=1 인 게시판만 내려옴)
const useBoardStore = create((set, get) => ({
  boards: null,
  loaded: false,
  failed: false,

  fetchBoards: async () => {
    try {
      const response = await boardService.listBoards();

      if (Array.isArray(response)) {
        set(() => ({ boards: response, loaded: true, failed: false }));
        return response;
      }
    } catch (e) {
      console.error(e);
    }

    // 실패 시 정적 메뉴로 폴백할 수 있도록 boards 는 null 유지
    set(() => ({ boards: null, loaded: true, failed: true }));
    return null;
  },

  getBoard: (moduleNo) => {
    const { boards } = get();
    if (!boards) {
      return null;
    }
    return boards.find((board) => Number(board.moduleNo) === Number(moduleNo)) || null;
  },
}));

export default useBoardStore;
